var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-message-circle-dashed-icon lucide-message-circle-dashed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5 2 22l4.5-1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftWhite);
export default __webpack_public_path__ + "static/media/draft_white.1d74454fd28bfaee5690a87a23b581b0.svg";
export { ForwardRef as ReactComponent };